import type { DeliveryZoneCode } from '@noths/polaris-client-localisation';
import type { Price } from '@noths/polaris-dev-ts-types';

import type { DecoratedDeliveryOption, GroupedCountries } from 'src/redux/delivery/types';
import type { CatServiceAPIDeliveryOption } from 'src/services/cat-service-api/types/CatServiceAPIDeliveryOption';

export enum DeliveryBlockContextID {
  DeliveryArea = 'delivery-area',
  DeliveryOptions = 'delivery-options',
}

export interface DeliveryBlockOnCountryChangeArgs {
  contextID: DeliveryBlockContextID;
  selectedCountry: string;
  selectedZone: DeliveryZoneCode;
}

export interface DeliveryBlockStateProps {
  countryInfoMessage: string | null;
  deliveryOptions: DecoratedDeliveryOption[] | [];
  deliveryOptionsPlaceholderItems: CatServiceAPIDeliveryOption[];
  groupedCountries: GroupedCountries;
  loading: boolean;
  partnerFreeDeliveryThreshold: Price | null;
  photoUploadRequired: boolean;
  selectedCountry: string;
}

export interface DeliveryBlockDispatchProps {
  onCountryChange: (payload: DeliveryBlockOnCountryChangeArgs) => void;
}

interface DeliveryBlockOwnProps {
  contextID: DeliveryBlockContextID;
}

export type DeliveryBlockProps = DeliveryBlockStateProps &
  DeliveryBlockDispatchProps &
  DeliveryBlockOwnProps;
